<div class="grid">
	<div class="col-12">
		<div class="flex flex-row align-items-center justify-content-center gap-2 py-2 border-round-xl" [ngClass]="getColorBanner(permission.Status)">
			<div class="pi cm-quick-easy"></div>
			{{ 'PERMISSION' | translate }}: {{ permission.Status?.toUpperCase() | translate }}
			<!-- <p-tag [value]="permission.Status?.toUpperCase() | translate" [severity]="getColorStatus(permission.Status)"></p-tag> -->
		</div>
	</div>
	<!-- PERSONAL DATA -->
	<div class="col-12">
		<p-panel styleClass="p-panel-whitebg">
			<ng-template pTemplate="header">
				<div class="flex flex-row align-items-center justify-content-center">
					<i class="pi cm-user pr-2"></i>
					<label class="font-medium">{{ 'PERSONAL_DATA' | translate }} {{ 'CUSTOMER' | translate }}</label>
				</div>
			</ng-template>
			<ng-template pTemplate="content">
				<div class="grid pt-3">
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'CUSTOMER_NAME' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								{{ permission.Name }}
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'EMAIL' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								{{ permission.Email }}
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'DESCRIPTION' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								{{ permission.Description }}
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'LANGUAGE' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium gap-2"
								[ngClass]="simpleInputTextLayout('borderInput')">
								<img alt="{{ permission.CustomerLanguage }}" [src]="getCurrentLanguageFlag(permission.CustomerLanguage)" class="w-2rem">
								<div class="font-medium">{{ getLanguage(permission.CustomerLanguage) }}</div>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</p-panel>
	</div>
	<!-- TIME INFO -->
	<div class="col-12">
		<p-panel styleClass="p-panel-whitebg">
			<ng-template pTemplate="header">
				<div class="flex flex-row align-items-center justify-content-center">
					<i class="pi cm-date-time pr-2"></i>
					<label class="font-medium">{{ 'TIME_INFO' | translate }}</label>
				</div>
			</ng-template>
			<ng-template pTemplate="content">
				<div class="grid pt-3">
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'TIMEZONE' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								{{ permission.Tz }}
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'PERMISSION_CREATION_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								{{ permission.CreatedAt | localizedDate:'medium' }}
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'CHECK_IN' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								{{ permission.Start | localizedDate:'mediumDate':(permission.Tz || 'UTC') }} {{ permission.Start | localizedDate:'mediumTime':(permission.Tz || 'UTC') }}
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">{{ 'CHECK_OUT' | translate }}</div>
							<div class="flex align-items-center justify-content-center font-medium gap-2"
								[ngClass]="simpleInputTextLayout('borderInput')">
								{{ permission.End | localizedDate:'mediumDate':(permission.Tz || 'UTC') }} {{ permission.End | localizedDate:'mediumTime':(permission.Tz || 'UTC') }}
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</p-panel>
	</div>
	<!-- SETTINGS MAIL -->
	<div class="col-12">
		<p-panel styleClass="p-panel-whitebg">
			<ng-template pTemplate="header">
				<div class="flex flex-row align-items-center justify-content-center">
					<i class="pi cm-mail pr-2"></i>
					<label class="font-medium">{{ 'SETTINGS_MAIL' | translate }}</label>
				</div>
			</ng-template>
			<ng-template pTemplate="content">
				<div class="grid pt-3">
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">
								<i class="pi cm-mail pr-2"></i>
								{{ 'SEND_MAIL' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								<p-tag [value]="permission.SendMail ? ( 'SENT' | translate ) : ( 'NOT_SENT' | translate )"
									[styleClass]="permission.SendMail ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">
								<i class="pi cm-quick-easy pr-2"></i>
								{{ 'SEND_ACCESS_MAIL' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								<p-tag [value]="permission.SendAccessMail ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )"
								[styleClass]="permission.SendAccessMail ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</p-panel>
	</div>
	<!-- RBE -->
	<div *ngIf="commandsRbeByDevice?.size > 0" class="col-12">
		<p-panel styleClass="p-panel-whitebg">
			<ng-template pTemplate="header">
				<div class="flex flex-row align-items-center justify-content-center">
					<i class="pi cm-device-rbe pr-2"></i>
					<label class="font-medium">{{ 'SEND_TO_RBE' | translate }}</label>
				</div>
			</ng-template>
			<ng-template pTemplate="content">
				<div class="grid pt-3">
					<!-- Desktop / Tablet: RBE FULL COMMANDS LIST -->
					<div *ngIf="!onExtendedMobile()" class="col-12 py-0" [ngClass]="customPaddingX()">
						<div *ngFor="let entry of commandsRbeByDevice | keyvalue" class="col-12 px-0 pb-0">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="simpleInputTextLayout('borderRow')">
								<div class="flex align-items-center justify-content-center font-medium"
									[ngClass]="simpleInputTextLayout('label')">
									<i class="cm-device-rbe pr-2"></i>
									{{ entry.key | truncate:[20] }}
								</div>
								<div class="flex align-items-center justify-content-center font-medium gap-2"
									[ngClass]="simpleInputTextLayout('borderInput')">
									<p-tag *ngFor="let desc of entry.value" [value]="desc | truncate:[20]" severity="info"></p-tag>
								</div>
							</div>
						</div>
					</div>
					<!-- Mobile: RBE COMMANDS LIST (first 4 commands with ..others overlay)-->
					<div *ngIf="onExtendedMobile()" class="col-12">
						<div *ngFor="let entry of commandsRbeByDevice | keyvalue" class="col-12 px-0 pb-0">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="simpleInputTextLayout('borderRow')">
								<div class="flex align-items-center justify-content-center font-medium"
									[ngClass]="simpleInputTextLayout('label')">
									<i class="cm-device-rbe pr-2"></i>
									{{ entry.key | truncate:[20] }}
								</div>
								<div class="flex align-items-center justify-content-center font-medium gap-2 flex-wrap"
									[ngClass]="simpleInputTextLayout('borderInput')">
									<p-tag *ngFor="let desc of entry.value | slice:0:4" [value]="desc" severity="info"></p-tag>
									<span *ngIf="entry.value.length > 4"
										class="cursor-pointer font-medium text-primary white-space-nowrap"
										(click)="openRbeOthersOverlay($event, entry.value.slice(4), opRbeOthers)">
										(.. {{ 'OTHERS' | translate | lowercase }})
									</span>
								</div>
							</div>
						</div>
						<p-overlayPanel #opRbeOthers [style]="{width: '90vw', 'max-width': '22rem', 'align-items': 'center', 'justify-content': 'center'}">
							<div class="flex flex-wrap align-items-center justify-content-center gap-1">
								<p-tag *ngFor="let desc of rbeOthersOverlayItems" [value]="desc | truncate:[20]" severity="info"></p-tag>
							</div>
						</p-overlayPanel>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">
								<i class="pi cm-keypad pr-2"></i>
								{{ 'KEYPAD_CODE_ON_DEVICE' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								<p-tag [value]="permission.SendPincodeRbe ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )"
									[styleClass]="permission.SendPincodeRbe ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">
								<i class="pi cm-card pr-2"></i>
								{{ 'RFID_CARD_ON_DEVICE' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								<p-tag *ngIf="!permission.RfidQeCode" value="{{ 'NOT_ASSOCIATED' | translate }}"
									styleClass="p-tag-darkBlue10"></p-tag>
								<p-tag *ngIf="permission.RfidQeCode" [value]="permission.SendRfidRbe ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )"
									[styleClass]="permission.SendRfidRbe ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</p-panel>
	</div>
	<!-- MTMA -->
	<div *ngIf="commandsMtmaByDevice?.size > 0" class="col-12">
		<p-panel styleClass="p-panel-whitebg">
			<ng-template pTemplate="header">
				<div class="flex flex-row align-items-center justify-content-center">
					<i class="pi cm-derivate pr-2"></i>
					<label class="font-medium">{{ 'SEND_TO_MTMA' | translate }}</label>
				</div>
			</ng-template>
			<ng-template pTemplate="content">
				<div class="grid pt-3">
					<!-- Desktop / Tablet: MTMA FULL COMMANDS LIST -->
					<div *ngIf="!onExtendedMobile()" class="col-12 py-0" [ngClass]="customPaddingX()">
						<div *ngFor="let entry of commandsMtmaByDevice | keyvalue" class="col-12 px-0 pb-0">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="simpleInputTextLayout('borderRow')">
								<div class="flex align-items-center justify-content-center font-medium"
									[ngClass]="simpleInputTextLayout('label')">
									<i class="pi cm-derivate pr-2"></i>
									{{ entry.key | truncate:[20] }}
								</div>
								<div class="flex align-items-center justify-content-center font-medium gap-2"
									[ngClass]="simpleInputTextLayout('borderInput')">
									<p-tag *ngFor="let desc of entry.value" [value]="desc | truncate:[20]" severity="info"></p-tag>
								</div>
							</div>
						</div>
					</div>
					<!-- Mobile: MTMA COMMANDS LIST (first 4 commands with ..others overlay)-->
					<div *ngIf="onExtendedMobile()" class="col-12">
						<div *ngFor="let entry of commandsMtmaByDevice | keyvalue" class="col-12 px-0 pb-0">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="simpleInputTextLayout('borderRow')">
								<div class="flex align-items-center justify-content-center font-medium"
									[ngClass]="simpleInputTextLayout('label')">
									<i class="cm-device-rbe pr-2"></i>
									{{ entry.key | truncate:[20] }}
								</div>
								<div class="flex align-items-center justify-content-center font-medium gap-2 flex-wrap"
									[ngClass]="simpleInputTextLayout('borderInput')">
									<p-tag *ngFor="let desc of entry.value | slice:0:4" [value]="desc | truncate:[20]" severity="info"></p-tag>
									<span *ngIf="entry.value.length > 4"
										class="cursor-pointer font-medium text-primary white-space-nowrap"
										(click)="openMtmaOthersOverlay($event, entry.value.slice(4), opMtmaOthers)">
										(..altri)
									</span>
								</div>
							</div>
						</div>
						<p-overlayPanel #opMtmaOthers [style]="{width: '90vw', 'max-width': '22rem'}">
							<div class="flex flex-wrap align-items-center justify-content-center gap-1">
								<p-tag *ngFor="let desc of mtmaOthersOverlayItems" [value]="desc | truncate:[20]" severity="info"></p-tag>
							</div>
						</p-overlayPanel>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">
								<i class="pi cm-keypad pr-2"></i>
								{{ 'KEYPAD_CODE_ON_DEVICE' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								<p-tag [value]="permission.SendPincodeMtma ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )"
									[styleClass]="permission.SendPincodeMtma ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
							</div>
						</div>
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
							[ngClass]="simpleInputTextLayout('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="simpleInputTextLayout('label')">
								<i class="pi cm-card pr-2"></i>
								{{ 'RFID_CARD_ON_DEVICE' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center font-medium"
								[ngClass]="simpleInputTextLayout('borderInput')">
								<p-tag *ngIf="!permission.RfidQeCode" value="{{ 'NOT_ASSOCIATED' | translate }}"
									styleClass="p-tag-darkBlue10"></p-tag>
								<p-tag *ngIf="permission.RfidQeCode" [value]="permission.SendRfidMtma ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )"
									[styleClass]="permission.SendRfidMtma ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</p-panel>
	</div>
	<!-- AUTOMATIONS -->
	<div *ngIf="commandsAutomationsByDevice?.size > 0" class="col-12">
		<p-panel styleClass="p-panel-whitebg">
			<ng-template pTemplate="header">
				<div class="flex flex-row align-items-center justify-content-center">
					<i class="pi cm-configuration pr-2"></i>
					<label class="font-medium">{{ 'AUTOMATIONS_COMMANDS' | translate }}</label>
				</div>
			</ng-template>
			<ng-template pTemplate="content">
				<div class="grid pt-3">
					<!-- Desktop / Tablet: AUTOMATIONS FULL COMMANDS LIST -->
					<div *ngIf="!onExtendedMobile()" class="col-12 py-0" [ngClass]="customPaddingX()">
						<div *ngFor="let entry of commandsAutomationsByDevice | keyvalue" class="col-12 px-0 pb-0">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="simpleInputTextLayout('borderRow')">
								<div class="flex align-items-center justify-content-center font-medium"
									[ngClass]="simpleInputTextLayout('label')">
									<i class="pi {{ entry.value.iconName }} pr-2"></i>
									{{ entry.key | truncate:[20] }}
								</div>
								<div class="flex align-items-center justify-content-center font-medium gap-2"
									[ngClass]="simpleInputTextLayout('borderInput')">
									<p-tag *ngFor="let desc of entry.value.commands" [value]="desc | truncate:[20]" severity="info"></p-tag>
								</div>
							</div>
						</div>
					</div>
					<!-- Mobile: AUTOMATIONS COMMANDS LIST (first 4 commands with ..others overlay)-->
					<div *ngIf="onExtendedMobile()" class="col-12">
						<div *ngFor="let entry of commandsAutomationsByDevice | keyvalue" class="col-12 px-0 pb-0">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="simpleInputTextLayout('borderRow')">
								<div class="flex align-items-center justify-content-center font-medium"
									[ngClass]="simpleInputTextLayout('label')">
									<i class="pi {{ entry.value.iconName }} pr-2"></i>
									{{ entry.key | truncate:[20] }}
								</div>
								<div class="flex align-items-center justify-content-center font-medium gap-2 flex-wrap"
									[ngClass]="simpleInputTextLayout('borderInput')">
									<p-tag *ngFor="let desc of entry.value.commands | slice:0:4" [value]="desc | truncate:[20]" severity="info"></p-tag>
									<span *ngIf="entry.value.commands.length > 4"
										class="cursor-pointer font-medium text-primary white-space-nowrap"
										(click)="openAutomationsOthersOverlay($event, entry.value.commands.slice(4), opAutomationsOthers)">
										(..altri)
									</span>
								</div>
							</div>
						</div>
						<p-overlayPanel #opAutomationsOthers [style]="{width: '90vw', 'max-width': '22rem'}">
							<div class="flex flex-wrap align-items-center justify-content-center gap-1">
								<p-tag *ngFor="let desc of automationsOthersOverlayItems" [value]="desc | truncate:[20]" severity="info"></p-tag>
							</div>
						</p-overlayPanel>
					</div>
				</div>
			</ng-template>
		</p-panel>
	</div>
	<!-- THERMOSTATS -->
	<div *ngIf="permission.Ths?.length > 0" class="col-12">
		<p-panel styleClass="p-panel-whitebg">
			<ng-template pTemplate="header">
				<div class="flex flex-row align-items-center justify-content-center">
					<i class="pi cm-termo pr-2"></i>
					<label class="font-medium">{{ 'THERMOSTATS' | translate }}</label>
				</div>
			</ng-template>
			<ng-template pTemplate="content">
				<div class="grid pt-3">
					<div class="col-12">
						<div class="flex justify-content-center flex-wrap border-100 border-bottom-1 gap-2">
							<div *ngFor="let th of permission.Ths" class="font-medium">
								<i class="pi cm-termo pr-2"></i>
								{{ th.DeviceName | truncate:[30]}}
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</p-panel>
	</div>

	<div class="col-12 mt-3 flex justify-content-center">
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>